import type { ComposantEcran } from '../../app/ecrans.js';
import { EcranFicheHeritier } from './EcranFicheHeritier.js';

/** Écrans fournis par le lot L55 au registre de la coquille : D05, fiche héritier. */
export const ecrans: Record<string, ComposantEcran> = { D05: EcranFicheHeritier };
